query customerCommentsQuery(
  $customerId: String!
  $first: Int = 10
  $offset: Int = 0
  $orderBy: [CommentsOrderBy!] = [CREATED_AT_DESC]
) {
  comments: allComments(
    first: $first
    offset: $offset
    orderBy: $orderBy
    condition: { playerAccountId: $customerId }
  ) {
    totalCount
    nodes {
      id: commentId
      createdBy
      createdAt
      updatedAt
      edited
      content: commentContent
      replies: threadsByCommentId {
        totalCount
      }
    }
  }
}
